
<button #downloadButtonIntern class="{{classes}}" type="button" data-title="Download" (click)="download()">
    <span class="glyphicon glyphicon-download"> {{text}}</span>
</button>
